import { momentTimezone, setOptions } from "@mobiscroll/react";
import moment from "moment-timezone";
import { TIMELINE_TYPE } from "../../../constants";
import { ViewType } from "./types";

momentTimezone.moment = moment;

setOptions({
  theme: "material",
  themeVariant: "light",
});

export const COLORS = {
  currentBooking: {
    background: "#D7E0F7",
    text: "#7D0096",
  },
  otherBooking: {
    background: "#F2D4FF",
    text: "#7D0096",
  },
  badge: {
    background: "#0B41CD",
    text: "white",
  },
} as const;

export const STYLES = {
  resourceHeaderBadge: {
    width: "22px",
    height: "21px",
    backgroundColor: COLORS.badge.background,
    color: COLORS.badge.text,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  },
  resourceName: {
    marginRight: "10px",
    fontSize: "14px",
    lineHeight: "140%",
    fontFamily: "Roche Sans",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    minWidth: 0,
  },
} as const;

export const TIMELINE_BUFFER = {
  DAY: 7,
  "3DAY": 7,
  WEEK: 14,
  MONTH: 2,
} as const;

export const VIEW_CONFIG = {
  [TIMELINE_TYPE.DAY]: {
    timeline: {
      type: "day" as const,
      size: 60,
      resolutionHorizontal: "hour" as const,
      timeCellStep: 60,
      timeLabelStep: 60,
      currentTimeIndicator: true,
    },
  },
  [TIMELINE_TYPE["3DAY"]]: {
    timeline: {
      type: "day" as const,
      size: 60,
      timeCellStep: 360,
      timeLabelStep: 360,
      resolutionHorizontal: "hour" as const,
      currentTimeIndicator: true,
    },
  },
  [TIMELINE_TYPE.WEEK]: {
    timeline: {
      type: "day" as const,
      size: 90,
      timeCellStep: 1440,
      timeLabelStep: 1440,
      resolutionHorizontal: "day" as const,
      currentTimeIndicator: true,
    },
  },
  [TIMELINE_TYPE.MONTH]: {
    timeline: {
      type: "day" as const,
      size: 180,
      timeCellStep: 1440,
      timeLabelStep: 1440,
      resolutionHorizontal: "day" as const,
      currentTimeIndicator: true,
    },
  },
} as const;

export const NAVIGATION_UNITS: Record<string, moment.unitOfTime.DurationConstructor> = {
  [TIMELINE_TYPE.DAY]: "days",
  [TIMELINE_TYPE["3DAY"]]: "days",
  [TIMELINE_TYPE.WEEK]: "weeks",
  [TIMELINE_TYPE.MONTH]: "months",
};

export const VIEW_OPTIONS: Array<{ value: ViewType; label: string }> = [
  { value: TIMELINE_TYPE.DAY, label: "Day" },
  { value: TIMELINE_TYPE["3DAY"], label: "3 Days" },
  { value: TIMELINE_TYPE.WEEK, label: "Week" },
  { value: TIMELINE_TYPE.MONTH, label: "Month" },
];

export const DEBOUNCE_MS = 100;

export const BOOKING_ENTRIES_QUERY_LIMIT = 1000;
